/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

type IExceptionListResponse = IManageBaseListResponse;
type IExceptionResponse = IManageBaseResponse;

export const exceptionApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getExceptionList: builder.query<IExceptionListResponse, void>({
      query: () => ({
        url: routes.exception.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.EXCEPTION, getResponseData(result)),
            getListTag(TagTypes.EXCEPTION),
          ]
          : [getListTag(TagTypes.EXCEPTION)],
    }),

    getByIdException: builder.query<IExceptionResponse, number>({
      query: (id) => ({
        url: routes.exception.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.EXCEPTION)
    }),

    createException: builder.mutation<
      IExceptionResponse,
      { name: string }
    >({
      query: (data) => ({
        url: routes.exception.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.EXCEPTION)),
    }),

    updateException: builder.mutation<
      IExceptionResponse,
      WithId<{ name: string }>
    >({
      query: ([id, data]) => ({
        url: routes.exception.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.EXCEPTION)),
    }),

    deleteException: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.exception.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.EXCEPTION)),
    }),
  }),
});

export const {
  useGetExceptionListQuery,
  useLazyGetExceptionListQuery,
  useGetByIdExceptionQuery,
  useLazyGetByIdExceptionQuery,
  useCreateExceptionMutation,
  useUpdateExceptionMutation,
  useDeleteExceptionMutation
} = exceptionApi;




